import { IBrandCartV2 } from "@faire/web-api/faire/carts/IBrandCartV2";
import { ICartItemV2 } from "@faire/web-api/faire/carts/ICartItemV2";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import flatten from "lodash/flatten";
import groupBy from "lodash/groupBy";

import { IAddedCartItem } from "@faire/retailer/events";

export interface IProductItem {
  brand_token: string;
  product_token: string;
  price_cents: number;
  quantity: number;
}

const groupByProducts = (
  cartItems: ICartItemV2[]
): Record<string, ICartItemV2[]> =>
  groupBy<ICartItemV2>(cartItems, (cartItem) => cartItem.product_token);

const groupWithProductItems = (cartItems: ICartItemV2[]): IProductItem[] => {
  const groupedCartItems = groupByProducts(cartItems);
  const groupedCartItemsValues = Object.values(groupedCartItems);

  return groupedCartItemsValues.map((productCartItems) => {
    return productCartItems.reduce(
      (acc, item) => ({
        brand_token: item.brand_token || acc.brand_token,
        product_token: item.product_token || acc.product_token,
        price_cents: item.price?.amount_cents || acc.price_cents,
        quantity: acc.quantity + item.quantity!,
      }),
      {
        brand_token: "",
        product_token: "",
        price_cents: 0,
        quantity: 0,
      }
    );
  });
};

export const groupWithAddedProductItems = (addedItems: IAddedCartItem[]) => {
  const cartItemGroups = groupBy<IAddedCartItem>(
    addedItems,
    (items) => items.productToken
  );

  return Object.values(cartItemGroups).map((itemGroup) => {
    return itemGroup.reduce(
      (acc, item) => ({
        brand_token: item.brandToken!,
        product_token: item.productToken!,
        price_cents: item.addedPrice!,
        quantity: acc.quantity + item.addedQuantity,
      }),
      {
        brand_token: "",
        product_token: "",
        price_cents: 0,
        quantity: 0,
      }
    );
  });
};

export const getAvailableProductItems = (brandCarts: IBrandCartV2[]) =>
  groupWithProductItems(
    flatten(
      brandCarts.map((b) =>
        Object.values(b.cart_items).filter(isNotUndefined).slice(0)
      )
    )
  );
